import * as type from "./types";
import { updateObject } from "../../utils/utility";

const INITIAL_STATE = {
    policiesForUpdate: [],
    policyList: [],
    subsidiaryList: [],
    planList: [],
    policy: {
        policyNumber: '',
        subsidiaryNo: '',
        subsidiaryName: '',
        planId: null,
        planName: ''
    },
    requestList: [],
    request: {}
};

const storePolicyList = (state, action) => {
    return updateObject(
        state,
        { policyList: action.data}
    )
}

const storePolicy = (state, action) => {
    return updateObject(
        state,
        { policy: action.data}
    )
}

const storeSubsidiaryList = (state, action) => {
    return updateObject(
        state,
        { subsidiaryList: action.data}
    )
}

const storePlanList = (state, action) => {
    return updateObject(
        state,
        { planList: action.data}
    )
}

const storePoliciesForUpdate = (state, action) => {
    return updateObject(state, {
        policiesForUpdate: action.data
    })
}

const storeRequestList = (state, action) => {
    return updateObject(
        state,
        { requestList: action.data}
    )
}

const storeRequest = (state, action) => {
    return updateObject(
        state,
        { request: action.data}
    )
}

const resetPoliciesForUpdate = (state) => {
    return updateObject(
        state,
        { policiesForUpdate: [] }
    )
}

const resetState = (state) => {
    return updateObject(
        state,
        {
            policiesForUpdate: [],
            policyList: [],
            policy: {}
        }
    )
}


export const policyReducer = (state = INITIAL_STATE, action) => {
    switch ( action.type ) {
        case type.POLICY_STORE:
            return storePolicy(state, action);
        case type.POLICY_LIST_STORE:
            return storePolicyList(state, action);
        case type.SUBSIDIARY_LIST_STORE:
            return storeSubsidiaryList(state, action);
        case type.PLAN_LIST_STORE:
            return storePlanList(state, action);
        case type.REQUEST_LIST_STORE:
            return storeRequestList(state, action);
        case type.REQUEST_STORE:
            return storeRequest(state, action);
        case type.POLICY_FETCH_FAILED:
            return updateObject(
                state,
                { error: true }
            );
        case type.RESET_STATE:
            return resetState(state);
        case type.STORE_POLICIES_FOR_UPDATE:
            return storePoliciesForUpdate(state, action);
        case type.RESET_POLICIES_FOR_UPDATE:
            return resetPoliciesForUpdate(state);
        default:
            return state;
    }
}
